import { Banner } from "../../model/novedades/Banner";
import { GenericComponentProps } from "../../model/GenericComponentProps";
import { ModuleContainerGeneric } from "../ModuleContainerGeneric";
import { Carrousel } from "./Carrousel";
import { CssSwiper } from "./CssSwiper";
import { ErrorBoundary } from "../ErrorBoundary";

type BannerProps = {
  menuIcons?: JSX.Element;
  currencyBar?: JSX.Element;
  bannerCuentaRegresiva?: Banner;
} & GenericComponentProps<Banner>;

export function Novelties(props: BannerProps) {
  const banners: Banner[] = props.data;

  if (props.bannerCuentaRegresiva) {
    banners.splice(
      props.bannerCuentaRegresiva.orden,
      0,
      props.bannerCuentaRegresiva
    );
  }

  return (
    <ErrorBoundary>
      <ModuleContainerGeneric
        paddingTop={props.orden == 1 ? "0px !important" : "initial"}
        paddingX={[null, null, null, 59, 107]}
        backgroundColor={props.backgroundColor || "secondary.0"}
        css={CssSwiper}
      >
        {props.menuIcons}
        <Carrousel
          items={banners}
          fullBorderRadius={props.currencyBar ? false : true}
        />
        {props.currencyBar}
      </ModuleContainerGeneric>
    </ErrorBoundary>
  );
}
